import React from 'react';
import { Box, constants, Logo, Text } from '@match/react-component-library';
import { SiteCode, SITECODE } from '@match/app-rules-resolver';
import { SC3AdditionalFooterLinks } from './SC3AdditionalFooterLinks';
import styled from 'packages/theming';
import { useSiteCode } from 'modules/hooks';
import { MEDIA_QUERY } from 'modules/constants/media-queries';
import { defineMessages, FormattedMessage } from 'react-intl';

const { SPACE, SEMANTIC_COLOR_NAME } = constants;

const MAX_HEADER_WIDTH = 1156;

const getSiteData = (siteCode: SiteCode) => {
  switch (siteCode) {
    case SITECODE.STIR:
      return { siteUrl: 'https://www.stir.com', siteAria: 'stir.com' };
    case SITECODE.OUR_TIME:
      return { siteUrl: 'https://www.ourtime.com', siteAria: 'ourtime.com' };
    default:
      return { siteUrl: 'https://www.match.com', siteAria: 'match.com' };
  }
};

const Footer = () => {
  const { siteCode } = useSiteCode();
  const { siteUrl, siteAria } = getSiteData(siteCode);
  const isOurtime = siteCode === SITECODE.OUR_TIME;

  return (
    <StyledFooterBox width="100%" paddingX={SPACE.XLARGE}>
      <Box>
        <StyledLogoBox alignItems="center">
          <a href={siteUrl} target="_blank">
            <Logo
              size="abbreviated"
              width={60}
              height={55}
              color={SEMANTIC_COLOR_NAME.CORE3_100}
              aria-hidden
            />
            <span aria-label={siteAria} />
          </a>
          <Box paddingX="small">
            <Text typography="largeBody">
              <FormattedMessage
                {...(isOurtime ? messages.ourtimeFooterText : messages.tradeMark)}
              />
              &#8482;
            </Text>
          </Box>
          <SC3AdditionalFooterLinks />
        </StyledLogoBox>
      </Box>
    </StyledFooterBox>
  );
};

const StyledFooterBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  marginTop: SPACE.XXXLARGE,
  marginX: 'auto',
  maxWidth: MAX_HEADER_WIDTH,
  minHeight: 56,
  position: 'relative',
  width: '100%',
  margin: `${theme.space.xlarge}px ${theme.space.none}px`,
  [MEDIA_QUERY.MOBILE]: {
    marginTop: theme.space.none,
    marginBottom: theme.space.xxxlarge,
    justifyContent: 'center',
  },
}));

const StyledLogoBox = styled(Box)({
  left: SPACE.NONE,
  width: '100%',
  display: 'flex',
  [MEDIA_QUERY.MOBILE]: {
    justifyContent: 'center',
  },
});

const messages = defineMessages({
  tradeMark: {
    id: 'src/modules/components/Footer/Footer:tradeMark',
    description: 'trade mark Match Stories',
    defaultMessage: 'Match Stories',
  },
  ourtimeFooterText: {
    id: 'src/modules/components/Footer/Footer:ourtimeFooterText',
    description: 'ourtime footer text',
    defaultMessage: 'Ourtime Success Stories',
  },
});

export default Footer;
